import { useCallback } from "react";
import { useBuilderStore } from "@circle-react-shared/BuilderUI/Hooks/useBuilderStore";
import { generateGoogleFontsLinks } from "./googleFontsUtils";

export const useGoogleFonts = () => {
  const googleFonts = useBuilderStore(state => state.googleFonts);

  const getGoogleFontsLinks = useCallback(
    () => generateGoogleFontsLinks(googleFonts),
    [googleFonts],
  );

  return {
    getGoogleFontsLinks,
  };
};
